/**
 * NWScriptDefType enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file NWScriptDefType.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum NWScriptDefType {
  VOID = 0,
  INT = 3,
  FLOAT = 4,
  STRING = 5,
  OBJECT = 6,
  //
  EFFECT = 16,
  EVENT = 17,
  LOCATION = 18,
  TALENT = 19
}